import * as React from 'react';
import { ICardAssigneesDropdownProps } from './types';
import { CARD_ACTIONS_PORTAL, CARD_CLASS, CARD_CONTROL_CLASS, CARD_TEMPLATES_PORTAL } from '../../../../constants';
import './_CardAssigneesDropdown.scss';
import { UsersTooltip } from '../../../../../../base/components/UsersTooltip/UsersTooltip';
import { Button, ButtonDropdown, Icon } from 'kui';
import { SearchSelect } from '../../../../../../base/components/SearchSelect/SearchSelect';
import {
    AssigneesAdd
} from '../../../../../../aside_panel/cardDetails/AssigneesSection/components/AssigneesAdd/AssigneesAdd';
import { CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT } from '../../../../../../../abstracts/constants';
import { TOP_BAR_CLASS } from '../../../../../topBar/constants';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardAssigneesDropdown`) : null;

export function CardAssigneesDropdown({
    directionVertical,
    cardId,
    listId,
    searchSelectOptions,
    onClosed,
    onToggle,
}: ICardAssigneesDropdownProps) {
    if (analyzeRender) analyzeRender.call(`CardAssigneesDropdown ${cardId || listId}`);
    const className = CARD_CLASS + '__assignees';

    return <SearchSelect
        autoFocus
        className={className + '-search-select'}
        directionVertical={directionVertical}
        isCloseOnClick={false}
        isDropdownUplifted
        isFitWindow
        multiple
        opened
        options={searchSelectOptions}
        option={AssigneesAdd}
        variant={'search'}
        onClosed={onClosed}
        onSelect={onToggle}
    />;
}
